import { apiUc } from '../http';
export class ServiceCRUDBACKEND {
  /**
   * Busca todos os usuários que `login` tem acesso. Retorna um array de strings com os logins desses usuários.
   * @param {string} login
   * @returns {Promise<string>}
   */
  getAllowedUsersByLogin(login) {
    return apiUc.get(`api/usuarios/acessiveis/${login}`);
  }

  getAgentStatusSoftphoneByAgentCode(agentCode){
    return apiUc.get(`api/agent-status-softphone/agent-code/${agentCode}`);
  }

  // Busca informacoes por ramal
  getAgentStatusSoftphoneByRamal(ramal){
    return apiUc.get(`api/agent-status-softphone/extension/${ramal}`);
  }

// Registra um login no ramal
  registerAgentStatusSoftphone(data){
    return apiUc.post(`api/agent-status-softphone`, data);
  }

// Remove o login do ramal
  unregisterAgentStatusSoftphone(agentCode){
    return apiUc.delete(`api/agent-status-softphone/${agentCode}`);
  }
}
